export default __webpack_public_path__ + "static/media/Image-12.aec45319.jpg";